export default {
    "login": {
        "title": "Accede a tu cuenta",
        "email": "Email",
        "placeholderEmail": "Tu email de trabajo",
        "password": "Contraseña",
        "placeholderPassword": "Tu contraseña",
        "login": "Acceder",
        "forgot": "¿Has olvidado tu contraseña?"
    },
    "reset": {
        "title": "Establecer nueva contraseña",
        "text": "Establece tu nueva contraseña cumpliendo con los requisitos de seguridad mostrados más abajo."
    },
    "forgot": {
        "title": "He olvidado mi contraseña",
        "text": "¡No pasa nada! Escribe tu email y te enviaremos las instrucciones para establecer una nueva contraseña",
        "actions": {
            "back": "Volver",
            "send": "Enviar instrucciones"
        }
    }
};